module.exports = __webpack_public_path__ + "static/Nunito-Regular-65bb0a158ee1967292ee4d11079d45ae.ttf";